_.exists = function (collection, predicate = _.identity, fromIndex = 0) {
  return Boolean(_.find(collection, predicate, fromIndex))
}

_.existsIndex = function (collection, predicate = _.identity, fromIndex = 0) {
  return Boolean(_.findIndex(collection, predicate, fromIndex))
}

_.mapJoin = function (collection, key, separator = ', ') {
  return _.map(collection, key).join(separator)
}

_.spliceAt = function (collection, index, ...items) {
  return [
    ...collection.slice(0, index),
    ...items,
    ...collection.slice(index + 1)
  ]
}
